/// <reference path="logger.ts" />

module YVR.Utilities.Gtm {
	// Imports
	import logger = YVR.Utilities.Logger;

	const elements = {
		body: $('body')
	};

	/**
	 * Init - initializes all gtm and analytic events
	 */
	function main(): void {
		trackDownloads();
		trackGenericClickEvents();
		trackExitLinkEvents();
		trackMailtoEvents();
		trackSearchEvents();
		trackMiscEvents();
		trackLanguageEvents();
	}


	/**
	 * Helper function to push event to dataLayer
	 */
	export function eventToDataLayer(category: string, action: string, label: string, value?: string): void {
		if (typeof ((window as any).dataLayer) !== 'undefined') {
			const event: any = {
				event: 'GAevent',
				eventCategory: category,
				eventAction: action,
				eventLabel: label
			};

			if (value && value !== '') {
				event.eventValue = value;
			}

			(window as any).dataLayer.push(event);

			logger.log('[gtm][eventToDataLayer] Pushed GAevent:', category, action, label);
		} else if (typeof (window as any).ga !== 'undefined') {
			if (value && value !== '') {
				(window as any).ga('send', 'event', category, action, label, value);
			} else {
				(window as any).ga('send', 'event', category, action, label);
			}
		} else {
			logger.log('[gtm][eventToDataLayer] dataLayer variable not present. Events may not be recorded.');
		}
	}


	/**
	 * Tracks generic click events based on css class, and data attributes
	 */
	function trackGenericClickEvents(): void {
		elements.body.on('click', '[ga-category]', function () {
			const element = $(this);

			const category = element.data('ga-category');
			const action = element.data('ga-action');
			const label = element.data('ga-label');

			eventToDataLayer(category, action, label);
		});
	}


	/**
	 * Tracks exit link events (user's linking out of the site)
	 */
	function trackExitLinkEvents(): void {
		elements.body.on('click', 'a', function (e) {
			const $this = $(this);

			const url = $this.prop('href');
			let target = $this.attr('target');

			target = target ? target : '_self';

			if ((e.currentTarget as HTMLAnchorElement).host && (e.currentTarget as HTMLAnchorElement).host !== window.location.host) {
				eventToDataLayer('exit', 'external-link-click', url);
				eventToDataLayer('exit', 'external-link-target', target);
			}
		});
	}


	/**
	 * Tracks all mailto click events (triggering a new mail message)
	 */
	function trackMailtoEvents(): void {
		elements.body.on('click', 'a[href*="mailto:"]', function () {
			const label = $(this).attr('href').substring(7);

			eventToDataLayer('contact', 'email', label);
		});
	}


	/**
	 * Track coveo search related events
	 */
	function trackSearchEvents(): void {
		// If coveo is initialized, track search related events.
		if (typeof (window as any).Coveo !== 'undefined') {
			// Query success
			/*(window as any).Coveo.$('#search').on('querySuccess', (event, params) => {
				const page = Math.floor((params.queryBuilder.firstResult / params.queryBuilder.numberOfResults) + 1);

				if (params.results.totalCount === 0) {
					// No results - send no results event
					eventToDataLayer('search', 'zero-results', params.query.q);
				}

				const title = document.title;
				const cat = 'site search';
				const url = `${window.location.pathname}?term=${params.query.q}&cat=${cat}`;

				if (typeof ((window as any).dataLayer) !== 'undefined' && params.query.q !== undefined && page <= 1) {
					const data = { 'event': 'virtualPageView', 'virtualPageTitle': title, 'virtualPageUrl': encodeURIComponent(url) };

					(window as any).dataLayer.push(data);
					logger.log('[gtm][trackSearchEvents]', data);
				}

				if (page > 1) {
					eventToDataLayer('search', 'paging', page.toString());
				}
			});*/
		}
	}


	/**
	 * Track document downloads
	 */
	function trackDownloads(): void {
		elements.body.on('click', 'a[href*=".pdf"], a[href*=".xls"], a[href*=".xlsx"], a[href*=".doc"], a[href*=".docx"], a[href*=".txt"], a[href*=".ppt"], a[href*=".pptx"], a[href*=".zip"]', function (e) {
			e.stopImmediatePropagation();

			const label = $(this).attr('href');

			eventToDataLayer('documents', 'download', label);
		});

		elements.body.on('click', '[data-href*=".pdf"], [data-href*=".xls"], [data-href*=".xlsx"], [data-href*=".doc"], [data-href*=".docx"], [data-href*=".txt"], [data-href*=".ppt"], [data-href*=".pptx"], [data-href*=".zip"]', function () {
			const label = $(this).attr('data-href');

			eventToDataLayer('documents', 'download', label);
		});
	}


	/**
	 * Track misc events
	 */
	function trackMiscEvents(): void {
		// Track home logo clicks
		elements.body.on('click', '.yvr-logo', () => {
			eventToDataLayer('logo', 'click', '');
		});

		// Track dropdown links
		elements.body.on('click', '.yvr-navigation-secondary__dropdown-link', function () {
			eventToDataLayer('secondary-navigation', 'dropdown-click', $(this).prop('href'));
		});
	}


	/**
	 * Track language related events (language selector)
	 */
	function trackLanguageEvents(): void {
		const languages = $('.yvr-languages');

		languages.on('click', 'a', function () {
			if ($(this).hasClass('yvr-languages__link--disabled')) {
				eventToDataLayer('language', 'toggle-intent', $(this).text());
			} else {
				eventToDataLayer('language', 'toggle', $(this).text());
			}
		});
	}

	main();
}
